// utils/vatChecks.js
import { collection, getDocs, query, where, limit } from "firebase/firestore"
import { db } from "../firebase/config"

// Turn country code + raw vat into one string like "LV40103217882"
export function normalizeVat(countryCode, rawVat) {
  const cc = (countryCode || "").trim().toUpperCase()
  const num = (rawVat || "").replace(/\s+/g, "")
  return cc + num
}

// Check if a VAT already exists in either "clients" or "leads".
// If you're converting a lead to a client, you can pass its id as ignoreLeadId
// so the function won't block that conversion.
export async function checkVatExists(vatNormalized, ignoreLeadId = null) {
  // 1) Check in clients
  const clientsQuery = query(collection(db, "clients"), where("vat", "==", vatNormalized), limit(1))
  const clientsSnap = await getDocs(clientsQuery)

  if (!clientsSnap.empty) {
    const docSnap = clientsSnap.docs[0]
    return {
      exists: true,
      where: "clients",
      id: docSnap.id,
      name: (docSnap.data() && docSnap.data().client) || null,
    }
  }

  // 2) Check in leads
  const leadsQuery = query(
    collection(db, "leads"),
    where("vat", "==", vatNormalized),
    limit(5) // small cap; we just need to see if any exist
  )
  const leadsSnap = await getDocs(leadsQuery)

  // If we are converting a lead, don't count that same lead as a duplicate
  let foundLead = null
  leadsSnap.forEach((d) => {
    if (!foundLead && d.id !== (ignoreLeadId || "")) {
      foundLead = d
    }
  })

  if (foundLead) {
    return {
      exists: true,
      where: "leads",
      id: foundLead.id,
      name: (foundLead.data() && foundLead.data().client) || null,
    }
  }

  // 3) No duplicates found
  return { exists: false, where: null }
}
